
import { BlogPost, sortBlogPostsByDate } from './types';
import { beginnerPosts } from './beginners';
import { techniquesPosts } from './techniques';
import { musicTheoryPosts } from './music-theory';
import { inspirationPosts } from './inspiration';
import { advancedPosts } from './advanced';

// Combine all blog posts from different categories
export const allBlogPosts: BlogPost[] = [
  ...beginnerPosts,
  ...techniquesPosts,
  ...musicTheoryPosts,
  ...inspirationPosts,
  ...advancedPosts
];

// Export the sorted blog posts
export const blogPosts = sortBlogPostsByDate(allBlogPosts);

// Export individual category posts
export { 
  beginnerPosts,
  techniquesPosts,
  musicTheoryPosts,
  inspirationPosts,
  advancedPosts
};

// Re-export types and helper functions
export * from './types';
